import axiosInstance from "api/axiosInstance";

import type { PaginatedResponse } from "api/types/product.types";
import type { Ticket, PracticeTicket, TicketListParams, PracticeTicketListParams, AdminTicket, AdminTicketDetail, AdminTicketListParams, AdminTicketUpdateRequest, AdminOrderCancelRequest, AdminOrderCancelResponse } from "api/types/tickets.types";

const TICKETS_BASE = "/server/buccl_lessons/api/v1/tickets/";
const PRACTICE_TICKETS_BASE = "/server/buccl_lessons/api/v1/practice-tickets/";
const ADMIN_TICKETS_BASE = "/server/buccl_lessons/api/v1/admin/tickets/";

export const ticketsService = {
  list: (params?: TicketListParams) => axiosInstance.get<Ticket[]>(TICKETS_BASE, { params }),

  get: (id: number) => axiosInstance.get<Ticket>(`${TICKETS_BASE}${id}/`),
};

export const practiceTicketsService = {
  list: (params?: PracticeTicketListParams) => axiosInstance.get<PracticeTicket[]>(PRACTICE_TICKETS_BASE, { params }),

  get: (id: number) => axiosInstance.get<PracticeTicket>(`${PRACTICE_TICKETS_BASE}${id}/`),
};

// 어드민 전용 수강권(구매) 관리 — 목록/상세/수정/삭제/환불
export const adminTicketsService = {
  list: (params?: AdminTicketListParams) => axiosInstance.get<PaginatedResponse<AdminTicket>>(ADMIN_TICKETS_BASE, { params }),
  get: (id: number) => axiosInstance.get<AdminTicketDetail>(`${ADMIN_TICKETS_BASE}${id}/`),
  update: (id: number, payload: AdminTicketUpdateRequest) => axiosInstance.patch<AdminTicketDetail>(`${ADMIN_TICKETS_BASE}${id}/`, payload),
  remove: (id: number) => axiosInstance.delete(`${ADMIN_TICKETS_BASE}${id}/`),
  // 주문 취소 + 이노페이 PG 환불. id는 티켓 id가 아니라 주문(order) id.
  refund: (orderNum: number | string, cancelReason: string) => axiosInstance.post<AdminOrderCancelResponse>(`/server/buccl_main/api/v1/admin/orders/${orderNum}/cancel/`, { cancel_reason: cancelReason } as AdminOrderCancelRequest),
};
